import { createSlice } from "@reduxjs/toolkit";

export const incentiveSlice = createSlice({
  name: "incentives",
  initialState: {
    loading: false,
    error: null,
    incentivesByKey: {}, // Store as { "IT_Manager": { data: [], totalCount: {} } }
    // incentives: [], // Deprecated in favor of keyed storage
  },
  reducers: {
    getIncentivesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getIncentivesSuccess(state, action) {
      state.loading = false;
      const { key, data, totalCount } = action.payload;
      
      // Fix: API might return { data: { data: [...] } }
      const rawData = data;
      const actualList = Array.isArray(rawData) ? rawData : (rawData?.data || []);
      
      state.incentivesByKey = {
          ...state.incentivesByKey,
          [key]: {
              data: actualList,
              totalCount: totalCount
          }
      };
    },
    getIncentivesFailure(state, action) {
      state.loading = false;
      state.error = action.payload; // Global error
      
      // Also mark the specific key as failed so we don't retry locally
      if (action.payload?.key) {
           state.incentivesByKey = {
              ...state.incentivesByKey,
              [action.payload.key]: {
                  data: [],
                  totalCount: 0,
                  error: action.payload.error || true
              }
           };
      }
    },
    // Settings
    getIncentiveSettingsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getIncentiveSettingsSuccess(state, action) {
      state.loading = false;
      // Store settings by key
      // action.payload = { key: "INCENTIVE_BENCH", data: {...} }
      const { key, data } = action.payload;
      console.log('Storing settings in Redux:', { key, data });
      if (!state.incentiveSettings) state.incentiveSettings = {};
      state.incentiveSettings[key] = data;
    },
    getIncentiveSettingsFailure(state, action) {
        state.loading = false;
        state.error = action.payload;
    },
    saveIncentiveSettingsStart(state) {
        state.loading = true;
        state.error = null;
    },
    saveIncentiveSettingsSuccess(state, action) {
        state.loading = false;
        // Update the stored setting with new data
        const { key, data } = action.payload;
        if (!state.incentiveSettings) state.incentiveSettings = {};
        state.incentiveSettings[key] = data;
    },
    saveIncentiveSettingsFailure(state, action) {
        state.loading = false;
        state.error = action.payload;
    },
  },
});

export const {
  getIncentivesStart,
  getIncentivesSuccess,
  getIncentivesFailure,
  getIncentiveSettingsStart,
  getIncentiveSettingsSuccess,
  getIncentiveSettingsFailure,
  saveIncentiveSettingsStart,
  saveIncentiveSettingsSuccess,
  saveIncentiveSettingsFailure,
} = incentiveSlice.actions;

export default incentiveSlice.reducer;
